export default __webpack_public_path__ + "static/media/Left.23859319.dwg";